module.exports = __webpack_public_path__ + "static/DIY_bathbombs-98a6f5716e124acada2b8f63a25f9004.png";